/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UsersState } from './types';
import { fetchUsers } from './thunks';


const initialState: UsersState = {
  users: [],
  currentUser: null,
  isFetchingUsers: false,
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isFetchingUsers = true
      })
      .addCase(fetchUsers.fulfilled, (state, action: PayloadAction<User[]>) => {
        state.users = action.payload
        state.isFetchingUsers = false
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        console.error(action.error.message)
        state.isFetchingUsers = false
      })
  },
})

export const {

} = usersSlice.actions

export const { actions, reducer } = usersSlice
